import React, { useState, useEffect } from 'react';
import { useWeb3React } from '@web3-react/core';
import { UnsupportedChainIdError } from '@web3-react/core';

import { Modal } from '../Modal';
import { Icon } from '../Icon';

import { isNetworkSupported } from '../../hooks/contract/useContract';

export const UnsupportedNetworkModal: React.FC = () => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);

  const { error, chainId, account } = useWeb3React();

  useEffect(() => {
    const isUnsupportedChainIdError = error instanceof UnsupportedChainIdError;
    if (isUnsupportedChainIdError) {
      setDisplayModal(true);
    }

    if (!isNetworkSupported(chainId || 1) && account) {
      setDisplayModal(true);
    } else setDisplayModal(false);
  }, [error, chainId]);

  const onModalClose = (): void => {
    setDisplayModal(false);
  };

  return (
    <Modal open={displayModal} onClose={onModalClose}>
      <div className="unsupported-network center">
        <Icon icon="x" onClick={onModalClose} />
        <p>Seems like you are on unsupported network! Please switch your wallet to Mainnet or Goerli network.</p>
      </div>
    </Modal>
  );
};
